/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/games/collapse': {
    width: 16,
    height: 16,
    viewBox: '0 0 150 100',
    data: '<path pid="0" d="M10 90l65-80 65 80"/>'
  }
})
